import React, { useEffect, useCallback, useReducer, useState } from 'react';

import {
    TranslatedString,
    Form,
    useAjax,
    XhrStatus,
    formUpdateFieldValues,
    PrimaryButton
} from '@bosch/bt-ui';

import './PostCompanyForm.css';
import withErrorHandler from '../../../components/ErrorHandler';
import { useNavigate } from 'react-router-dom';
import NetworkConfigFields from './NetworkConfigFields';
import RpsControlFields from './RpsControlFields';
import CompanySettingsFields from './CompanySettingsFields';
import RestfulCallout from '../../../components/RestfulCallout';
import RestfulCallLoading from '../../../components/RestfulCallLoading';
import { prepareLogData } from '../../../components/Util';

function convertArrayToObject(targetArray) {
    const myObject = {}
    console.log(targetArray);
    for (let obj of targetArray) {
        myObject[obj] = true;
    }
    return myObject;
}

const PostCompanyForm = (props) => {
    const {
        token,
        setIsDirty,
        result,
        companyId,
        mode,
        onSuccess   
    } = props;
    const [ returnResult, statusc, runAjaxInner, responsec] = useAjax(XhrStatus.Initial);
    const navigate = useNavigate();
    const [rpsControlSettings, updateFormValues] = useReducer(formUpdateFieldValues, result.rpsControlSettings);
    const [companySettings, updateCompanySettings] = useReducer(formUpdateFieldValues, result.companySettings);
    const [companyInfo, updateCompanyInfo] = useReducer(formUpdateFieldValues, result.companyInfo);
    const [companyMobileAlertSettings, updateCompanyMobileAlertSettings] = useReducer(formUpdateFieldValues, result.companyMobileAlertSettings);
    const [networkConfigs, updateNetWorkModelFormValues] = useReducer(formUpdateFieldValues, result.networkModelSettings);
    const [subnetConfigs, updateSubnetFormValues] = useReducer(formUpdateFieldValues, result.companySubnets);
    const [mnvOsInUseSettings, updateMnvOsInUseSettings] = useReducer(formUpdateFieldValues, result.companySettings.mnvOsInUse, convertArrayToObject);
    const [updateResult, status, updateSetting, response] = useAjax(XhrStatus.Initial);
    const [emailErrorMsg, setEmailErrorMsg] = useState('');

    const onFormSubmit = useCallback(
        () => {
            
            setIsDirty(false)
            const mnvOsInUseObject = [];
            for (let obj in mnvOsInUseSettings) {
                if (mnvOsInUseSettings[obj])
                    mnvOsInUseObject.push(obj);
            }
            // console.log(mnvOsInUseObject);
            const newCompanySettings = {
                ...companySettings,
                mnvOsInUse: mnvOsInUseObject
            };
            const subnetPostConfigs = {
                ...subnetConfigs,
                cidr: subnetConfigs.cidr ?? 0
            };
            console.log(subnetPostConfigs)
            const updateSettingModel = {
                'companySettings': newCompanySettings,
                'rpsControlSettings': rpsControlSettings,
                'companyInfo': companyInfo,
                'companyMobileAlertSettings':companyMobileAlertSettings,
                'networkModelSettings': networkConfigs,
                'companySubnets': subnetPostConfigs,
                'mode': mode
            };

            const message  = mode === 'update' ? 'Update(a company)->Save : ' : 'Create Company->Save : ';
            const data = prepareLogData(token,'Company_Management', message +  companyInfo.companyName);
            // console.log(companyInfo);
            const restfulAction = mode === 'update' ? 'PUT' : 'POST';
            const url = mode === 'update' ? SUPPORTCONSOLE_API_URL + '/api/companymanager/v1/companies/' + encodeURIComponent(companyId) + '/rpscontrols' : SUPPORTCONSOLE_API_URL + '/api/companymanager/v1/companies/rpscontrols';
            updateSetting(restfulAction, url, null, updateSettingModel, { 'Authorization': 'Bearer ' + token.token });
			//Add activity log
			fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': 'Bearer ' + token.token
				},
				body: JSON.stringify(data)
			  })	
        },
        [setIsDirty, companySettings, subnetConfigs, rpsControlSettings, companyInfo, companyMobileAlertSettings, networkConfigs, mode, updateSetting, companyId, token.token, mnvOsInUseSettings]
    );

    useEffect(() => {
        if (status === XhrStatus.Finished && updateResult.status === 'Success') {
            setIsDirty(false);
            navigate(
                '/company/update/' + encodeURIComponent(updateResult.data.companyId),
                {
                state: {
                    updateState: updateResult,
                    isCreation: mode !== 'update'
                }
            }
            );
            // navigate({
            //     pathname: '/company/update/' + encodeURIComponent(updateResult.data.companyId),
            //     state: {
            //         updateState: updateResult,
            //         isCreation: mode !== 'update'
            //     }
            // })
            if (onSuccess) {
                onSuccess();
            }
        }
    }, [status, updateResult, navigate, setIsDirty, mode,onSuccess]);


    return (
        <div id="post-company">
            <RestfulCallout status={status} response={response} returnObj={updateResult} />
            {
				<Form
					formAttributes={{
						onSubmit: onFormSubmit,
						method: 'post',
						action: '',
						onChange: () => setIsDirty(true),
						onClick: () => setIsDirty(true)
					}}
				>
					<div id="post-company-content">
						<CompanySettingsFields
							formValues={companySettings}
							updateFormValues={updateCompanySettings}
							mnvoValues={mnvOsInUseSettings}
							updateMnvoValues={updateMnvOsInUseSettings}
							companyInfo={companyInfo}
                            updateCompanyInfoValues={updateCompanyInfo}
                            companyMobileAlertSettings={companyMobileAlertSettings}
                            updatecompanyMobileAlertValues={updateCompanyMobileAlertSettings}
							mode={mode}
                            emailErrorMsg={emailErrorMsg}
                            setEmailErrorMsg={setEmailErrorMsg}
						/>
						<RpsControlFields
							formValues={rpsControlSettings}
							updateFormValues={updateFormValues}
							mode={mode}
						/>
						<NetworkConfigFields
							netWorkFormValues={networkConfigs}
							subnetFormValues={subnetConfigs}
							updateNetworkFormValues={updateNetWorkModelFormValues}
							updateSubnetFormValues={updateSubnetFormValues}
							mode={mode}
						/>
						<div className="submit-company">
							<PrimaryButton type="submit" disabled={!!emailErrorMsg}>
								<TranslatedString stringId="Save" />
							</PrimaryButton>
						</div>
                        <div style={{ color: '#eff1f2' }}>
                            <div>{`companySettings: companyId ${companySettings.companyId}, Created ${new Date(companySettings.createDate).toLocaleString()}, Updated ${new Date(companySettings.updateDate).toLocaleString()}`}</div>
                            <div>{`companyInfo: companyId ${companyInfo.companyId}, Created ${new Date(companyInfo.createDate).toLocaleString()}, Updated ${new Date(companyInfo.updateDate).toLocaleString()}`}</div>
                            <div>{`companyMobileAlertSettings: companyId ${companyMobileAlertSettings.companyId}, Created ${new Date(companyMobileAlertSettings.createDate).toLocaleString()}, Updated ${new Date(companyMobileAlertSettings.updateDate).toLocaleString()}`}</div>
                            <div>{`rpsControlSettings: companyId ${rpsControlSettings.companyId}, Created ${new Date(rpsControlSettings.createDate).toLocaleString()}, Updated ${new Date(rpsControlSettings.updateDate).toLocaleString()}`}</div>
                            <div>{`networkConfigs: companyId ${networkConfigs.companyId}, networkModelId ${networkConfigs.networkModelId}, Created ${new Date(networkConfigs.createDate).toLocaleString()}, Updated ${new Date(networkConfigs.updateDate).toLocaleString()}`}</div>
                            <div>{`subnetConfigs: companyId ${subnetConfigs.companyId}, subnetId ${subnetConfigs.subnetId}`}</div>
                        </div>
					</div>
				</Form>
            }
            <RestfulCallLoading status={status} />
        </div>
    );
};

export default withErrorHandler(React.memo(PostCompanyForm));
